<template>
  <div class="main-container">
    <div class="search-box min">
      <div class="input-item">
        <Input type="text" v-model="searchParams.keyword" placeholder="您可以输入保司、产品名称或其他关键字进行资料检索" clearable @on-enter="handleSearch()" />
      </div>
      <div class="btn-item">
        <Button type="primary" @click="handleSearch()">查询</Button>
        <Button type="primary" ghost @click="handleReset()">重置</Button>
      </div>
    </div>

    <div class="box">
      <Tabs v-if="statsList && statsList.length" v-model="currTabIdx" :animated="false" @on-click="onChangeTab">
        <TabPane v-for="(tab, idx) in statsList" :key="idx" :label="getNumText(tab)" :name="tab._idx" />
      </Tabs>

      <div v-if="tableData && tableData.length" class="table-box setTable">
        <div class="list-container">
          <div v-for="item in tableData" :key="item._idx" class="list-item">
            <div class="result-item">
              <div class="result-item-left">
                <div v-if="isShowLogo" class="result-pic">
                  <img v-if="item.companyLogo" :src="item.companyLogo" />
                </div>
                <div class="result-name">{{ item.title }}</div>
                <div v-if="item._tagName" class="result-tag">{{ item._tagName }}</div>
              </div>
              <div class="result-btns">
                <div class="result-btn" v-if="item.videoUrl" @click="viewVideo(item)">视频</div>
                <div class="result-btn" v-if="item.longPicList && item.longPicList.length" @click="viewImg(item, 'longPicList')">长图</div>
                <div class="result-btn" v-if="item.handbookList && item.handbookList.length" @click="viewPdf(item, 'handbookList')">
                  手册
                </div>
                <div class="result-btn" v-if="item.type == 2 && item.fileUrlList && item.fileUrlList.length" @click="viewImg(item, 'fileUrlList')">
                  资料({{ item.fileUrlList.length }})
                </div>
                <div class="result-btn" v-if="item.type == 3 && item.fileUrlList && item.fileUrlList.length" @click="viewPdf(item)">
                  资料({{ item.fileUrlList.length }})
                </div>
                <div v-if="item.canDownload" class="result-btn" @click="downloadFile(item)">下载</div>
              </div>
            </div>
          </div>
        </div>
        <Page
          :total="total"
          :current="pageNum"
          :page-size="pageSize"
          show-total
          @on-change="getList"
          :page-size-opts="[10, 20, 30, 50, 100]"
          style="text-align: center"
        />
      </div>
      <loading :isShow="loading" />
      <noData
        v-if="!loading && tableData && !tableData.length"
        class="noData"
        :imgUrl="require('@static/images/noData2.png')"
        seizeText="未检索到内容，请更换关键字"
      />
    </div>
    <Modal class="my-modal video-modal" v-model="videoModalVisible" title="视频" :transfer="false" footer-hide :mask-closable="false" width="800">
      <video v-if="videoModalVisible" class="video" controls :src="currItemObj.videoUrl" :poster="currItemObj.coverImg"></video>
    </Modal>
    <!-- 海报预览 -->
    <div class="prev-img-list">
      <img v-for="(bean, i) in previewImg" :key="bean.path" :src="bean.path" preview="img" :id="'img' + i" />
    </div>
    <!-- pdf预览 -->
    <pdf-view ref="pdfView" />
  </div>
</template>

<script>
import lzDicTxt from '@/components/commons/lzDicTxt';
import lzSelect from '@/components/commons/lzSelect';
import pdfView from '@/components/commons/pdfView';
import { pageTool, common } from '@/api/mixins';
import _ from 'lodash';

let PRODUCT_TYPE2 = null;
const codes = ['PRODUCT_INFORMATION', 'PRODUCT_POSTER'];

function getIsProduct(cols = [], method = 'every') {
  return codes[method](code => cols.includes(code));
}

export default {
  mixins: [pageTool, common],
  components: {
    lzSelect,
    lzDicTxt,
    pdfView
  },
  data() {
    return {
      loading: false,
      columns: [
        {
          title: '',
          key: 'name',
          width: 150
        },
        {
          title: '',
          key: 'action',
          width: 150
        }
      ],
      currTabIdx: '0',
      currTabObj: {},
      searchParams: {
        keyword: ''
      },
      // listData: [],
      statsList: [],
      videoModalVisible: false,
      currItemObj: {},
      previewImg: []
    };
  },
  computed: {
    isShowLogo() {
      return getIsProduct(_.get(this.currTabObj, 'columnCodes', []));
    }
  },
  filters: {
    productTypeFilter(val) {
      return PRODUCT_TYPE2[val];
    }
  },
  created() {
    this.dic = JSON.parse(localStorage.dic);
    this.PRODUCT_TYPE2 = this.dic['PRODUCT_TYPE2'];
    PRODUCT_TYPE2 = this.PRODUCT_TYPE2;
    this.initListParams('/buz/articleBase/queryInfoList');
  },
  activated() {
    this.handleSearch();
  },
  methods: {
    onChangeTab(newName) {
      this.loading = true;
      this.currTabObj = this.statsList[newName];
      this.pageNum = 1;
      this.tableData = [];
      this.$nextTick(() => {
        // 不知道为什么调用searchAjax不会执行getList方法，故此直接调用getList
        // this.searchAjax();
        this.listLoading = true;
        this.getList();
      });
    },
    getStatsData(keyword) {
      this.statsList = [];
      return this.$http({
        url: '/buz/articleBase/queryInfoStat',
        type: 'POST',
        data: {
          keyword: keyword || this.searchParams.keyword,
          pageNo: this.searchParams.pageNo,
          pageSize: this.searchParams.pageSize
        }
      }).then(res => {
        res.data = res.data || [];
        if (!res.data.length) {
          this.loading = false;
          this.tableData = [];
          this.statsList = [];
          this.total = 0;
          return res;
        }
        res.data = res.data.map((item, idx) => {
          item._idx = `${idx}`;
          this._mode = item.moduleCode;
          if (getIsProduct(item.columnCodes, 'some')) {
            item._mode = 'productData';
          }
          return item;
        });
        this.statsList = res.data;
        return res;
      });
    },
    setListParams(params) {
      if (this.currTabObj.columnCodes) {
        params.columnCodes = this.currTabObj.columnCodes;
      }
      if (this.currTabObj.moduleCode) {
        params.moduleCode = this.currTabObj.moduleCode;
      }
    },
    listCallback(res) {
      res.data = res.data.map((item, idx) => {
        item._idx = `${idx}`;
        item._mode = item.moduleCode;
        if (getIsProduct([item.columnCode], 'some') && item.productType) {
          item._mode = 'productData';
          item._tagName = PRODUCT_TYPE2[item.productType];
        } else if (item.moduleCode === 'COMMON_USE_TOOLS' && item.columnName) {
          item._tagName = item.columnName;
        } else if (item.moduleCode === 'ACTIVITY_SUMMARY' && item.companyName) {
          item._tagName = item.companyName;
        } else {
          item._tagName = item.columnName;
        }
        const typeMap = {
          1: '产品',
          2: '资讯',
          3: '活动'
        };
        item._typeDesc = typeMap[item.type] || '';
        item.fileUrlList = item.fileUrlList || [];
        item.longPicList = item.longPicList || [];
        item.handbookList = item.handbookList || [];
        item.canDownload = item.fileUrlList.length || item.longPicList.length || item.handbookList.length;
        return item;
      });
      this.loading = false;
    },
    handleSearch() {
      this.listData = [];
      this.statsList = [];
      this.loading = true;
      this.getStatsData()
        .then(res => {
          const firstTab = this.statsList[0];
          if (!firstTab) {
            console.warn('没有数据');
            return;
          }
          this.currTabIdx = '0';
          this.currTabObj = firstTab;
          this.$nextTick(() => {
            // 不知道为什么调用searchAjax不会执行getList方法，故此直接调用getList
            // this.searchAjax();
            this.listLoading = true;
            this.pageNum = 1;
            this.getList();
          });
        })
        .catch(() => {
          this.loading = false;
        });
    },
    handleReset() {
      this.searchParams.keyword = '';
      this.statsList = [];
      this.tableData = [];
      this.currTabIdx = '0';
      this.currTabObj = {};
      // 重置完成之后重新搜索
      this.handleSearch();
    },
    // 获取统计数据文本
    getNumText(obj) {
      obj = obj || {};
      return `${obj.moduleName}(${obj.resultNum})`;
    },
    viewVideo(item) {
      this.currItemObj = item;
      this.videoModalVisible = true;
    },
    viewPdf(item, key = 'fileUrlList') {
      this.$refs.pdfView.open(item[key]);
    },
    viewImg(item, key) {
      this.previewImg = item[key];
      this.$nextTick(() => {
        this.$previewRefresh();
        window.setTimeout(() => {
          const event = new MouseEvent('click', {
            view: window,
            bubbles: true,
            cancelable: true
          });
          document.getElementById('img0').dispatchEvent(event);
        }, 300);
      });
    },
    // 下载
    downloadFile(item) {
      // if (item.fileUrlList && item.fileUrlList.length == 1) {
      //   this.$units.downloadFun({ url: item.fileUrlList[0].path });
      // } else {
      // this.$units.downloadFun({
      //   url: '/buz/articleBase/downAll',
      //   params: {
      //     id: item.id
      //   }
      // });
      // }
      if (this.isShowLogo) {
        this.$units.downloadFun({
          url: '/buz/articleBase/downProductInfo',
          params: {
            productId: item.productId
          }
        });
      } else {
        this.$units.downloadFun({
          url: '/buz/articleBase/downAll',
          params: {
            id: item.id
          }
        });
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.search-box {
  .input-item {
    width: 360px !important;
  }
}
.box {
  background-color: #fff;
  flex: 1;
}
.noData {
  padding-top: 200px;
  min-height: 100%;
  /deep/ img {
    width: 280px;
    height: 120px;
    margin-bottom: 37px;
  }
}
.result-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #f0f0f0;
  // font-family: 'PingFang SC';
  height: 110px;
  .result-item-left {
    flex: 1;
    display: flex;
    align-items: center;
  }
  .result-pic {
    height: 55px;
    width: 55px;
    border-radius: 8px;
    background-color: #f1f1f1;
    overflow: hidden;
    margin-right: 22px;
    img {
      height: 100%;
      width: 100%;
      object-fit: cover;
    }
  }
  .result-name {
    font-weight: 500;
    font-size: 16px;
    color: #303133;
    line-height: 22px;
  }
  .result-tag {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 10px;
    height: 20px;
    padding: 0 8px;
    border-radius: 2px;
    border: 1px solid #ff7f00;
    font-weight: 400;
    font-size: 12px;
    color: #ff7f00;
    flex-wrap: nowrap;
    white-space: nowrap;
  }
  .result-btns {
    display: flex;
    flex-wrap: nowrap;
    font-weight: 400;
    font-size: 14px;
    color: #236dff;
    line-height: 20px;
    .result-btn {
      height: 20px;
      line-height: 20px;
      cursor: pointer;
      padding: 0 12px;
      position: relative;
      &::after {
        position: absolute;
        right: 0;
        top: 50%;
        margin-top: -6px;
        content: '';
        display: inline-block;
        width: 1px;
        height: 12px;
        background-color: #d8d8d8;
      }
      &:last-child {
        &::after {
          display: none;
        }
      }
    }
  }
}
.video-modal {
  /deep/.ivu-modal-body {
    padding: 10px;
  }
  /deep/ .video {
    width: 100%;
    height: 438px;
    background-color: #000;
  }
}
.prev-img-list {
  position: absolute;
  z-index: -1;
  top: -99999px;
}
</style>
